module.exports = __webpack_public_path__ + "img/system.221979db.png";